export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="currentColor" />
    <path d="M26 12h12v14h14v12H38v14H26V38H12V26h14z" fill="var(--logo-cross, #fff)" />
    <path d="M14 47c6-4 12-4 18 0s12 4 18 0" fill="none" stroke="#38BDF8" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-3">
    <span className={dark ? "text-white [--logo-cross:#0A192F]" : "text-[#0A192F]"}>
      <LogoMark />
    </span>
    <span className="leading-none">
      <span className={`block text-lg font-extrabold tracking-tight ${dark ? "text-white" : "text-[#0A192F]"}`}>Trentvale</span>
      <span className={`eyebrow !text-[10px] ${dark ? "text-sky-300" : "text-sky-700"}`}>Nursing</span>
    </span>
  </span>
);
